import { render, staticRenderFns } from "./printTerminalWriteOffLegend.vue?vue&type=template&id=aa1223b6&scoped=true&"
import script from "./printTerminalWriteOffLegend.vue?vue&type=script&lang=js&"
export * from "./printTerminalWriteOffLegend.vue?vue&type=script&lang=js&"
import style0 from "./printTerminalWriteOffLegend.vue?vue&type=style&index=0&id=aa1223b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1223b6",
  null
  
)

export default component.exports